
import axios from 'axios';
import { API_KEY, BASE_URL, getAxiosConfig } from '../../components/interface/Config';
import { apiHandler } from '../authService';

const API_URL = `${BASE_URL}/resource/patientHistories`;

export const fetchSurgicalHistory = async (token: string, params: Record<string, any>) => {
    try {
        console.log("Fetching Surgical History with token:", token);
        const response = await axios.get<{ data: {
            patient_histories: any; patient_healths: any[], pagination: { total: number } 
} }>(API_URL, {
            params,
            headers: getAxiosConfig().headers
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch surgical history.');
    }
};

export const deleteSurgicalHistory = async (token: string, surgicalHistoryId: number) => {
    try {
        const url       = `${API_URL}/${surgicalHistoryId}`;
        const response  = await apiHandler(token, 'DELETE',{}, url);

        if (!response) {
            throw new Error("No response received from the server");
        }

        // await axios.delete(`${API_URL}/${surgicalHistoryId}`, {
        //     headers: {
        //         Authorization: `Bearer ${token}`,
        //         'X-API-Key': API_KEY,
        //         'Content-Type': 'application/json',
        //     },
        // });

        return response;
    } catch (error) {
        throw new Error('Error deleting surgical history.');
    }
};
